import { API } from '../../utils';
import { IParams } from '../types';

export const CompressRequestVideo = (data: FormData) =>
  API.unparsedPost(
    '/ffmpeg_processing/video_processing/video_convert_to_mp4/',
    data
  ).then((res) => res.json()); // парсится только response

/*
  При передаче file_id в params не парсить response из json
  (кроме остальных случаев)
*/
export const GetProcessedMedia = (taskId: string, params?: IParams) =>
  API.gatewayUnparsedGet(
    '/ffmpeg_processing/task/',
    params ? `${taskId}/processed_file` : taskId,
    params
  );

export const DeleteProcessedMedia = (taskId: string, fileId: IParams) =>
  API.delete(
    `/ffmpeg_processing/task/${taskId}/processed_file_delete/?file_id=${fileId}`,
    undefined
  );
